<template>
    <v-card :id="id" color="grey lighten-2">
        <psi-card-heading
            :headingTitle="title"
            :icon="icon"
            :heading-color="headingColor"
        >
            <v-tooltip top color="accent darken-2">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="accent darken-2"
                        v-on="on"
                        v-bind="attrs"
                        @click.stop="dialog = true"
                        :disabled="htmlReport.length === 0"
                    >
                        <v-icon>mdi-file-table</v-icon>
                    </v-btn>
                </template>
                <span>View Credit Report</span>
            </v-tooltip>

            <v-tooltip top color="accent darken-2">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="ml-2"
                        color="accent darken-2"
                        v-on="on"
                        v-bind="attrs"
                        :href="reportUrl"
                        target="_blank"
                        :disabled="reportUrl.length === 0"
                    >
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                </template>
                <span>Print Credit Report</span>
            </v-tooltip>
        </psi-card-heading>
        <v-card-text>
            <credit-summary
                v-if="$_.has(search, 'hart.creditScore.score')"
                :search="search"
            ></credit-summary>
            <div class="mt-4" v-else>
                <v-alert border="top" outlined icon="mdi-credit-card-remove">
                    Credit Report Unavailable
                </v-alert>
            </div>
        </v-card-text>
        <v-dialog fullscreen v-model="dialog">
            <psi-dialog
                v-if="dialog"
                title="Credit Report"
                hide-actions
                @close="dialog = false"
            >
                <div
                    v-html="htmlReport"
                    style="max-width: 1040px"
                    class="mx-auto"
                ></div>
            </psi-dialog>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name: "screening-process-credit",
    components: {
        CreditSummary: () =>
            import("@components/screen/components/Credit/CreditSummary"),
    },
    props: {
        id: {
            type: String,
            required: false,
            default: "screening-credit",
        },
        headingColor: {
            type: String,
            required: false,
            default: "primary",
        },
        title: {
            type: String,
            required: false,
            default: "Blank",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-card-text",
        },
        height: {
            type: [String, Number],
            required: false,
            default: 600,
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 200,
        },
        summary: {
            type: Object,
            required: true,
        },
        reports: {
            type: Array,
            required: true,
        },
        search: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
    computed: {
        htmlReport() {
            const report = this.reports.find(
                (report) => report.type === "hart"
            );
            return report != undefined && report != null ? report.html : "";
        },
        reportUrl() {
            const report = this.reports.find(
                (report) => report.type === "hart"
            );
            return report != undefined &&
                report != null &&
                report.print_credit_report_url !== null
                ? report.print_credit_report_url
                : "";
        },
    },
    methods: {},
    mounted() {},
};
</script>

